import { Box, Typography, keyframes } from "@mui/material";
import { Link } from "react-router-dom";
// import SearchBar from "../components/SearchBar";
import SearchBar from "../../components/SearchBar";

const descendAnimation = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const defaultProps = {
  bgcolor: "transparent",
  position: "absolute",
  top: 30,
  // px: "7%",
  px: 5,
  "& .header-link": {
    display: "flex",
    // "@media (max-width: 1400px)": {
    //   display: "none",
    // },
  },
};

const stickyProps = {
  bgcolor: "white",
  position: "fixed",
  top: 0,
  px: 5,
  borderBottom: 1,
  borderColor: "divider",
  animation: `${descendAnimation} .2s ease-out forwards`,
  "& .header-link": {
    display: "none",
    // "@media (max-width: 1400px)": {
    //   display: "none",
    // },
  },
  "& .search-bar": {
    border: 1,
    borderRadius: 3,
    borderColor: "divider",
  },
};

export function HeaderSection({ shouldSticky }: { shouldSticky: boolean }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      zIndex={900}
      right={0}
      left={0}
      sx={defaultProps}
    >
      <Box
        className="header-link"
        flex={1}
        display="flex"
        py={2}
        maxWidth="1440px"
        alignItems="center"
        width="100%"
        
      >
        <Box
          height="40px"
          width="110px"
          component="img"
          src="/images/appIconHeader.png"
        />
        <Typography
          component={Link}
          to=""
          textTransform="none"
          fontWeight="bold"
          color="white"
          variant="h6"
          sx={{
            textDecoration: "none",
            marginLeft: 1,
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          掲載店舗数No.1
        </Typography>
        <Box component="sup" sx={{ color: "white", verticalAlign: "super" }}>
          ※
        </Box>
        <Typography sx={{ px: 2 }} variant="h6" fontWeight="bold" color="white">
          レストラン検索・予約サイト
        </Typography>

        <Box display="flex" flex={1} />

        <Typography
          component={Link}
          to=""
          textTransform="none"
          fontWeight="bold"
          color="white"
          variant="h6"
          sx={{
            px: 2,
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          食べログについて
        </Typography>
        <Typography
          component={Link}
          to=""
          textTransform="none"
          fontWeight="bold"
          color="white"
          variant="h6"
          sx={{
            px: 2,
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          無料会員登録・ログイン
        </Typography>
      </Box>

      <Box className="search-bar" my={2} width="100%" maxWidth="1440px">
        <SearchBar />
      </Box>
    </Box>
  );
}
